import { WhmBox, WhmContainer } from "@securitize/reactjs-whm";
import UserMenuContainer from "../../components/UserMenu";

export default function UserMenuView() {
  return (
    <WhmContainer>
      <WhmBox>
        <UserMenuContainer
          onLogout={() => null}
          onSwitchUser={async () => {}}
        />
      </WhmBox>
    </WhmContainer>
  );
}
